import React from "react";

import { faInfoCircle } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../../atoms/Icon";
import { Text } from "../../../atoms/Text";
import { Tooltip } from "../../Tooltip";
import { useInputField } from "../InputContext";

/**
 * An info icon that is displayed on the right of the label
 */
export const InputInfo = () => {
	const { info, error } = useInputField();

	if (!info) return null;

	const tooltipContent =
		typeof info === "string" ? (
			info
		) : (
			<div className="flex flex-col gap-1">
				{info.title && (
					<Text size="paragraph-3" weight="semi-bold" color="neutral-0">
						{info.title}
					</Text>
				)}
				{info.title && info.titleBottomLine && <div className="border-t border-neutral-6" />}
				<Text size="paragraph-3" weight="regular" color="neutral-0">
					{info.message}
				</Text>
			</div>
		);

	return (
		<Tooltip content={tooltipContent}>
			<Icon icon={faInfoCircle} size={16} color={error ? "red-5" : "neutral-7"} aria-label="More information" />
		</Tooltip>
	);
};
